const headerCard = {
    props: {
        card: {
            type: Object,
            default() {
                return null;
            },
        },
    },
    template: `
    <template v-if="card!==null && enableCache">
        <div  class="b-header-card">
            <img class="b-header-card__bg" :src="cardBg" alt="" />
            <div class="b-product-card">
                <div v-if="card.tpTl && card.tpTl !==''" class="b-product-card__head" :class="card.hasVerticalLogo == true ? 'b-product-card__head--vertical-logo' : ''"  v-html="card.tpTl">
                </div>
                <div class="b-product-card__conts">
                    <span v-if="card.prNotifClass && card.prNotifText" class="e-pr-notif" :class="card.prNotifClass"> {{card.prNotifText}}</span>
                    <div class="b-product-card__title" v-html="card.tl"></div>
                    <div class="b-product-card__txt">
                        <div class="b-product-card__txt__descr" v-html="card.dscr"></div>
                        <ul v-if="card.ul && card.ul.length">
                            <li v-for="li in card.ul">{{li}}</li>
                        </ul>
                    </div>
                    <div v-if="card.cmbUl && card.cmbUl.length" class="b-product-card__extra">
                        <div v-if="card.cmb" class="b-product-card__extra__title">{{card.cmb}}</div>
                        <ul class="b-combine">
                            <li v-for="li in card.cmbUl">
                                <figure v-if="li.icn" class="b-combine__icon"><img :src="li.icn" alt=""></figure>
                                <div class="b-combine__txt">
                                    <em v-if="li.tl && li.tl!==''">{{li.tl}}</em>
                                    <span v-if="li.tx && li.tx!==''">{{li.tx}}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div v-if="card.url && card.url!==''" class="btn-wrap">
                        <a :href="card.url" class="b-product-card__btn">{{card.urtx}}</a>
                    </div>
                </div>
            </div>
        </div>        
    </template>`,
    data() {
        return {
            enableCache: false,
        };
    },
    mounted() {
        jQuery(document).on("ini-ready", () => {
            this.checkToEnable()
        });
        jQuery(document).on("window-resized", ()=>{
            this.checkToEnable()
        })
    },
    methods:{
        checkToEnable(){
            if (api.vars.windW >= 1185) {
                this.enableCache = true;
            }
        }
    },
    computed: {
        cardBg() {
            if (this.card !== null && this.card.bg && this.card.bg !== "") {
                return this.card.bg;
            }
            return "";
        }
    },
};
